import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useTEMPLATE
 */

type State = {
    idsBancoPagamento: number[]
    status: number;
};

type Action = {
    setStatus: (status: number) => void,
    setIdsBancoPagamento: (list: number[]) => void,
    clearFilters: () => void
};

export const useBancoPagamentoListaFilters = create<State & Action>((set) => ({
    idsBancoPagamento: [],
    status: 2,
    setIdsBancoPagamento: (list) => set({ idsBancoPagamento: list }),
    setStatus: (status) => set({ status }),
    clearFilters: () => set({
        status: 2,
        idsBancoPagamento: []
    }),
}));

export const initialBancoPagamentoFiltersValues: State = {
    status: 2,
    idsBancoPagamento: []
}